import { render } from "./GeoStati.vue?vue&type=template&id=5d193508&scoped=true"
import script from "./GeoStati.vue?vue&type=script&lang=js"
export * from "./GeoStati.vue?vue&type=script&lang=js"

import "./GeoStati.vue?vue&type=style&index=0&id=5d193508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d193508"]])

export default __exports__